import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiUserViewProfileTabBase } from '@fi-app/user/fi-user-view-dialog/fi-user-view-profile-tab-group/fi-user-view-profile-tab-base';

@Component({
    selector: 'fi-user-view-profile-work-profile-tab',
    templateUrl: './fi-user-view-profile-work-profile-tab.component.html',
    styleUrls: ['./fi-user-view-profile-work-profile-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-view-profile-work-profile-tab' },
    standalone: false,
})
export class FiUserViewProfileWorkProfileTabComponent extends FiUserViewProfileTabBase {}
